import { createAction, props } from '@ngrx/store';
import { SellPreviewResponseInterface } from 'sp-arch-lib';
import { CompleteSelling } from 'sp-ui-lib';

export const countdown = createAction(
  '[RedirectMessage] Countdown From Ten'
);

export const updateCounter = createAction(
  '[RedirectMessage] Update Counter Value',
  props<{ counterValue: number }>()
);

export const storeSellResponse = createAction(
  '[RedirectMessage] Store Sell Response',
  props<{ sellResponse: CompleteSelling }>()
);

export const storeSellResponseStatus = createAction(
  '[RedirectMessage] Store Sell Response Status',
  props<{ sellResponse: SellPreviewResponseInterface }>()
);
